module.exports = __webpack_public_path__ + "img/maintenance-icon.69557147.png";